import { mediaQueries } from '@centivo/react-components'
import styled from 'styled-components'

export const NavlistSlice = styled.ul`
  box-shadow: none !important;

  display: flex;

  @media ${mediaQueries.mobile} {
    position: fixed;
    display: flex;
    flex-direction: column;
    min-width: 20rem;
    min-height: 100vh;
  }

  a {
    color: ${({ theme }) => theme.palette.brand.newPurple};
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.375rem;
  }

  a:hover {
    text-decoration: underline;
  }

  & li:not(:last-child) {
    margin-right: 2.5rem;
  }

  hr {
    visibility: hidden;
    border-top: 1px solid ${({ theme }) => theme.palette.brand.darkGreen};

    margin-top: 0.75rem;
    margin-bottom: 0;
    width: 100%;
  }

  @media ${mediaQueries.mobile} {
    background-color: ${({ theme }) => theme.palette.neutral.white};

    color: ${({ theme }) => theme.palette.brand.newPurple};
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.375rem;

    padding-top: 3.5rem;

    li {
      padding: 1rem 2.75rem 0.25rem 1.25rem;

      display: block;
      width: 100%;
    }

    a {
      color: ${({ theme }) => theme.palette.brand.darkGreen};
      width: 100%;
    }

    a:hover {
      text-decoration: none;
    }

    a > p {
      width: 100%;
    }

    a:hover > hr {
      visibility: visible;
    }
  }
`
